import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';

import ReactClientWallet from '@primusmoney/react_client_wallet';

import App from './app/react-js-ui/js/app.js';

console.log('loading index.js');

// app config
var EXEC_ENV = 'prod';


App.EXEC_ENV = EXEC_ENV;

async function beforeAppLoad() {
	return true;
}

try {
	var react_client_wallet = ReactClientWallet.getObject();

	if (EXEC_ENV === 'prod')  {
		// suppress logs early, before doing it in App.onLoaded()
		// to avoid all the logs of react_client_wallet.init
		if (window.simplestore)	window.simplestore.noconsoleoverload = false;

		// could use react_client_wallet.muteConsoleLog() for version >= 0.30.11
	}

 	console.log('starting initialization of react client wallet in index.js');
	react_client_wallet.init()
	.then( (res) => {
		return beforeAppLoad();
	})
	.then((res) => {
		if (res) {
			console.log('initialization of react client wallet finished in index.js');

			var clientglobal = react_client_wallet.getGlobalObject();

			if (EXEC_ENV === 'dev') {
				clientglobal.setExecutionEnvironment('dev');
				console.log('Execution environment turned to dev in index.js');
			}

			
			var appcore = App.getAppObject();

			return appcore.onLoaded();
		}
		else {
			throw new Error('react client wallet did not initialize correctly');
		}
	})
	.then((res) => {
		console.log('app core is now loaded in index.js');
	})
	.catch((err) => {
		console.log('error initializing react client wallet : ' + err);
	});

}
catch(e) {
	console.log('exception in index.js: ' + e);
	console.log(e.stack);
}
 
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
